var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useEffect, useState } from "react";
import { Charisma as CharismaSDK } from "@charisma-ai/sdk";
import { CharismaContext } from "./Context";
export const useCharisma = ({ playthroughToken, charismaUrl, onConnect = () => { }, onReady = () => { }, onError = () => { }, isConnected = false }) => {
    const [charisma, setCharisma] = useState();
    const onConnectRef = useRef(onConnect);
    useEffect(() => {
        onConnectRef.current = onConnect;
    }, [onConnect]);
    const onReadyRef = useRef(onReady);
    useEffect(() => {
        onReadyRef.current = onReady;
    }, [onReady]);
    const onErrorRef = useRef(onError);
    useEffect(() => {
        onErrorRef.current = onError;
    }, [onError]);
    useEffect(() => {
        if (playthroughToken) {
            const newCharisma = new CharismaSDK(playthroughToken, { charismaUrl });
            newCharisma.on("connect", onConnectRef.current);
            newCharisma.on("ready", onReadyRef.current);
            newCharisma.on("error", onErrorRef.current);
            setCharisma(newCharisma);
            return () => {
                newCharisma.cleanup();
            };
        }
        return undefined;
    }, [playthroughToken]);
    useEffect(() => {
        if (charisma) {
            if (isConnected) {
                charisma.connect();
            }
            else {
                charisma.cleanup();
            }
        }
    }, [isConnected, charisma]);
    return charisma;
};
export const Charisma = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const charisma = useCharisma(props);
    return (React.createElement(CharismaContext.Provider, { value: charisma || null }, typeof children === "function" ? children(charisma) : children));
};
//# sourceMappingURL=Charisma.js.map